import type {
  ConversationNodeContactForm,
  ConversationNodeMessengerFormAsContactForm,
} from 'lib-shared-types-api';

type Props = {
  node:
    | ConversationNodeContactForm
    | ConversationNodeMessengerFormAsContactForm;
};

export function RoutedThroughContactForm({ node }: Props): JSX.Element {
  return (
    <>
      Contact form <strong>{node.form_title ?? ''}</strong>
    </>
  );
}
